import api from '@/services/api/api';

export const useScienceBySlug = (slug) => {
  const scienceSlug = useQuery(
    ['scienceSlug', slug],
    async () => {
      const { data } = await api.articles.getArticleBySlug(slug);
      return data;
    },
    {
      isEnabled: computed(() => !!slug),
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await scienceSlug.suspense();
  });

  return {
    scienceSlug,
  };
};
